import home from "./home";
import monitor from "./monitor";
import reports from "./reports";
import users from "./users";
import skills from "./skills";
import calls from "./calls";
import login from "./login";
import profile from "./profile";
import sms from "./sms";
import chat from "./chat";
import kpi from "./kpi";
import forgotPassword from "./forgotPassword";
import campaigns from "./campaigns";
import ivr from "./ivr";
import smartRouting from "./smartRouting";
import settings from "./settings";
const en = {
  of: "of",
  loading: "Loading...",
  layouts: {
    Home: "Dashboard",
    Monitor: "Monitor Board",
    Reports: "Reports",
    Agent_Reports: "Agent Repoerts",
    Agent_Calls_Report: "Agent Calls",
    Agent_Status_Report: "Agent Status",
    Calls_Reports: "Calls",
    Performance_By_Period: "Performance By Period",
    Total_Performance: "Total Performance",
    Agent_Performance: "Agent Performance",
    System_Inbound: "System Inbound",
    Agent_Leaving_Details: "Agent Leaving Details",
    Agent_Leaving_Summary: "Agent Leaving Summary",
    Agent_Login_Details: "Agent Login Details",
    Agent_Login_Summary: "Agent Login Summary",
    Agent_Status_Details: "Agent Status Details",
    Agent_Status_Summary: "Agent Status Summary",
    Agent_KPI_Report: "Agents KPIs",

    Admin: "Admin",
    Users_Management: "Users Management",
    "users-management": "Users Management",
    "create-user": "Users Management",
    Skill_Management: "Queues Management",
    Calls_Management: "Calls Management",
    profile: "Profile",
    "sms-page": "SMS",
    logout: "Logout",
    Domains: "Domains",
    Procesors: "Processors",
    chat: "Internal Communication",
    "chat-user": "Internal Communication",
    "social-media": "Social Media",
    Profile: "Profile",
    logout_text: "Are you sure you want to logout?",
    "ai-assistant": "AI Assistant",
    "agent-status-report": "Agent Status Report",
    "agent-calls-report": "Agent Calls Report",
    "monitor-board": "Monitor Board",
    "skills-management": "Queues Management",
    "kpi-management": "KPI Management",
    "call-analysis": "Call Analysis",
    "voice-cdr-details": "Voice Call Details",
    "chat-transcript-details": "Chat Transcript",
    "campaigns-management": "Campaigns",
    "campaign-new": "New Campaign",
    "campaign-edit": "Edit Campaign",
    "campaign-sounds": "Campaign Sounds",
    "campaign-reports": "Campaign Reports",
    "ivr-management": "IVR Builder",
    "ivr-new": "New IVR Flow",
    "ivr-edit": "Edit IVR Flow",
    "ivr-sounds": "IVR Sounds",
    settings: "Settings",
    "settings-queues": "Queues Management",
    "settings-queue-config": "Configure Queue",
    "settings-vip": "VIP Numbers",
    "settings-blacklist": "Blacklist",
    "settings-reasons": "Call Reasons",
    "settings-crm": "CRM",
    "settings-rating": "Call Rating",
    "settings-call-settings": "Call Settings",
    "settings-kpi": "KPI Management",
    "settings-users": "Users Management",
    "settings-rest-periods": "Rest Periods",
  },
  general: {
    confirm: "Confirm",
    cancel: "Cancel",
  },
  home: home.en,
  login: login.en,
  monitor: monitor.en,
  reports: reports.en,
  users: users.en,
  skills: skills.en,
  calls: calls.en,
  profile: profile.en,
  sms: sms.en,
  chat: chat.en,
  kpi: kpi.en,
  forgot_password: forgotPassword.en,
  campaigns: campaigns.en,
  ivr: ivr.en,
  smart_routing: smartRouting.en,
  settings: settings.en,
};

export default en;
